import { FC, useState, useEffect } from "react";
import { Table } from "antd";
import { YhBox } from "@/components/YhBox";
import { ColumnsType } from "antd/es/table";
import { useMaintenanceDetailsModel } from "../MaintenanceModel";
import { RouterParamType } from "@/model/navModel";
import { OtherItemDetailList } from "../MaintenanceType";


export const OtherItem: FC<RouterParamType> = ({ id, mode }) => {

    const { otherItemDetailList } = useMaintenanceDetailsModel();

    const [totalPrice, setTotalPrice] = useState<string>("0");

    const title = <>
        <span>其他项目</span>
        <span style={{ marginLeft: '50px', fontSize: '14px' }}>
            总金额&nbsp;¥&nbsp;<span style={{ color: 'red', fontSize: '18px' }}>{totalPrice}</span>
            &nbsp;元&nbsp;({otherItemDetailList.length}项){" "}
        </span>
    </>

    //计算总价
    useEffect(() => {
        let num: number = 0
        otherItemDetailList.forEach((item) => {
            num += Number(item.itemAmount)
        })
        setTotalPrice(num.toFixed(2));
    }, [otherItemDetailList])

    const itemColumn: ColumnsType<OtherItemDetailList> = [
        {
            title: '序号',
            width: 50,
            align: "center",
            render: (t: any, r: any, i: number) => <>{i + 1}</>
        }, {
            title: "项目编码",
            align: "center",
            width: 120,
            dataIndex: "itemCode",
        },
        {
            title: "项目名称",
            align: "center",
            width: 200,
            dataIndex: "itemName",
        },
        {
            title: "项目属性",
            align: "center",
            width: 120,
            dataIndex: "itemAttr",
        },
        {
            title: "项目性质",
            align: "center",
            width: 200,
            dataIndex: "serviceNature",
        },
        {
            title: "单价",
            align: "center",
            width: 80,
            dataIndex: "unitPrice",
        },
        {
            title: "数量",
            align: "center",
            width: 80,
            dataIndex: "itemNumber",
        },
        {
            title: "总计",
            align: "center",
            width: 80,
            dataIndex: "itemAmount",
        },
        {
            title: "总金额",
            align: "center",
            width: 80,
            dataIndex: "actualAmount",
        },
        {
            title: "备注",
            align: "center",
            width: 200,
            dataIndex: "remark",
        },
    ];
    return (
        <YhBox title={title} style={{ marginBottom: 10, paddingBottom: 10 }}>
            <Table
                rowKey={record => record.id as string}
                rowClassName='editable-row yh-edit-table-tr'
                columns={itemColumn}
                dataSource={otherItemDetailList}
                pagination={false}
                scroll={{ x: 'max-content', y: 250 }}
            />
        </YhBox>
    )
}